const FermentationPrimary = ({ className }) => {
  return (
    <div className={`round-icon ${className}`}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 150 150"
        enableBackground="new 0 0 150 150"
        xmlSpace="preserve"
      >
        <g>
          <path
            d="M23.7,147.689L24,150h103.2L139,12.42l-2.55-0.92C70.62-12.75,14.3,10.55,11.94,11.56l-2.4,1L15,64.63 M21.81,62.22
		l-2-19.34c10.15-3.56,51.94-15.78,109.5,0.24L120.75,143H31.167 M129.891,36C73.17,20.53,32.14,31.23,19,35.67l-2-18.56
		c11.18-4,59.74-19.08,114.42,0.07L129.891,36z"
          />
        </g>
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          cx="42.247"
          cy="121.496"
          r="6.5"
        />
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          cx="59.747"
          cy="102.52"
          r="11"
        />
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          cx="35.747"
          cy="61.434"
          r="11"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          d="M104.947,112.615c7.182,0,13,5.817,13,13
	s-5.818,13-13,13s-13-5.817-13-13S97.766,112.615,104.947,112.615z"
        />
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          cx="111.865"
          cy="58.434"
          r="8"
        />
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          cx="85.947"
          cy="101.15"
          r="6"
        />
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          cx="111"
          cy="91.15"
          r="6"
        />
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          cx="62.562"
          cy="72.434"
          r="5"
        />
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          cx="70.747"
          cy="131.615"
          r="6"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          d="M87.785,66.149c5.524,0,10,4.476,10,9.999
	c0,5.525-4.476,10-10,10s-10-4.475-10-10C77.785,70.625,82.261,66.149,87.785,66.149z"
        />
        <circle
          fill="none"
          stroke="#000000"
          strokeWidth="3"
          strokeMiterlimit="10"
          cx="35.747"
          cy="88.72"
          r="5"
        />
      </svg>
    </div>
  );
};

export default FermentationPrimary;
